const body = document.querySelector('body');
const home = body.classList.contains('home');

if (home) {
    // Animation Scroll for Big Picture
    function animBigPicture() {

        const wH                = window.innerHeight
        const bigPicture        = document.getElementById('bigPicture')
        const bigPicturePos     = bigPicture.getBoundingClientRect().top
        const bigPictureOffset  = 200

        const bigPictureCalc    = ((bigPicturePos / (wH - bigPictureOffset) * 100)) / 100

        if(bigPictureCalc < 1 && bigPictureCalc > 0) {
            document.body.style.setProperty('--bigPictureScroll', bigPictureCalc );
        }
        else if(bigPictureCalc > 1) {       
            document.body.style.setProperty('--bigPictureScroll', 1);
        }
        else if(bigPictureCalc < 0) {
            document.body.style.setProperty('--bigPictureScroll', 0)
        }
    }

    if(window.innerWidth > 1200) {
        window.addEventListener('scroll', () => {

        animBigPicture()

    }, false);
    }


    const btnVideoAdminArea = document.querySelector('.js-admin-area__btn-video');
    const btnCloseVideoAdminArea = document.querySelector('.js-admin-area__btn-video--close');
    const videoAdminArea = document.querySelector('.js-admin-area__video');

    if (btnVideoAdminArea && btnCloseVideoAdminArea && videoAdminArea) {

        btnVideoAdminArea.addEventListener('click', () => { 
            videoAdminArea.classList.add('admin-area__video--visible');
        });

        btnCloseVideoAdminArea.addEventListener('click', () => { 
            videoAdminArea.classList.remove('admin-area__video--visible');
        });

    }
}



